export const config = {
  mixins: [],
  data() {
    return {
      columns: []
    };
  },
  methods: {
    // 获取表格列
    getColumns() {
      let columns = [];
      if (this.sureStatus == '0') {
        columns.push({
          type: 'selection',
          width: 60,
          align: 'center'
        });
      }
      columns = columns.concat([
        {
          title: '结算周期',
          align: 'center',
          key: 'commissionPeriod',
          minWidth: 120,
          tooltip: true
        },
        {
          title: '结算类型',
          minWidth: 120,
          align: 'center',
          tooltip: true,
          key: 'settlementType',
          render(h, params) {
            const flag = params.row.settlementType;
            if (flag == '1') {
              return <span>首期</span>;
            } else if (flag == '2') {
              return <span>续期</span>;
            } else if (flag == '3') {
              return <span>周边服务</span>;
            }
          }
        },
        {
          title: '保单数',
          key: 'totalNumber',
          align: 'center',
          minWidth: 120,
          render(h, params) {
            const totalNumber = params.row.totalNumber;
            return <span>{totalNumber || '-'}</span>;
          }
        },
        {
          title: '结算保费',
          key: 'totalPrice',
          align: 'center',
          minWidth: 120
        },
        {
          title: '结算积分',
          align: 'center',
          key: 'settleCommission',
          minWidth: 120,
          renderHeader: (h, params) => {
            return (
              <Poptip trigger="hover" content="content" transfer={true}>
                <span>结算积分</span>
                <span class="tip-icon">?</span>
                <div slot="content">
                  <p>对于保单积分类型的结算，结算积分=保单净积分（保单单位）*当期结算时的实际汇率=结算积分，</p>
                  <p>如有需要扣除的部分，在此基础上会扣除。结算积分保留两位小数，四舍五入。</p>
                </div>
              </Poptip>
            );
          }
        },
        {
          title: '状态',
          align: 'center',
          key: 'withdrawStatus',
          minWidth: 120,
          render: (h, params) => {
            if (this.sureStatus == '0') {
              return <span>待确认</span>;
            }
            const status = params.row.withdrawStatus;
            if (status == '0') {
              return <span>待打款</span>;
            } else if (status == '1') {
              return <span>已打款</span>;
            }
          }
        }
      ]);
      if (this.sureStatus == 1) {
        columns.push({
          title: '打款时间',
          align: 'center',
          key: 'subCompanyName',
          minWidth: 140,
          render(h, params) {
            const value = params.row.paymentTime ? params.row.paymentTime.substr(0, 10) : '-';
            return <div>{value}</div>;
          }
        });
      }
      columns.push({
        title: '操作',
        align: 'center',
        slot: 'action',
        width: 120,
        fixed: 'right'
      });
      this.columns = columns;
    }
  }
};
